import {
  MdcButton,
  MdcDialog,
  MdcDialogActions,
  MdcDialogContent,
  MdcDialogHeader,
  MdcGrid,
  MdcTypography
} from 'ids-wc/dist/react/components';
import { useEffect, useRef } from 'react';

export const BiometricSetupConfirmModal = (props: { shouldShow: boolean }) => {
  const refDialog = useRef<HTMLMdcDialogElement>(null);

  useEffect(() => {
    if (props.shouldShow) {
      refDialog.current?.open();
    }
  }, [props.shouldShow]);

  return (
    <MdcDialog id="biometrics-confirm-info" variant="alert" dialogTitleId={`biometrics-confirm-dialog`} ref={refDialog}>
      <MdcDialogHeader
        spacingBottom="none"
        spacingTop="loose"
        icon="check"
        iconColor="success"
        iconSize="xl"
        dialogTitleVariant="headline3"
        dialogTitle={'Τα βιομετρικα στοιχεία ενεργοποιήθηκαν με επιτυχία.'}
        dialogTitleId={`biometrics-confirm-title`}
      ></MdcDialogHeader>
      <MdcDialogContent>
        <MdcTypography
          variant="body2"
          color="textPrimary"
          textAlign="center"
          text="Τώρα μπορείτε να συνδέεστε εύκολα και με ασφάλεια."
        ></MdcTypography>
      </MdcDialogContent>
      <MdcDialogActions>
        <MdcGrid row rowFlex direction="column">
          <MdcGrid col={12}>
            <MdcButton
              id="action-1"
              fullWidth
              label="Κλείσιμο"
              onClick={() => {
                refDialog.current?.close();
              }}
              disableFocusRing
            />
          </MdcGrid>
        </MdcGrid>
      </MdcDialogActions>
    </MdcDialog>
  );
};
